<div class="fixed z-50" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <!-- Background Overlay -->
    <div class="fixed inset-0 bg-[#D4D7DE] dark:bg-[#3333331f] bg-opacity-75 transition-opacity backdrop-blur-sm"></div>
    <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
            <div class=" fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16">
                <div class="w-screen max-w-3xl px-2 py-2 bg-white dark:bg-zinc-950 h-screen overflow-scroll">
                    <!-- Modal Content -->
                    <div>
                        <form class="mt-4 px-4">
                            <div class="flex justify-between">
                                <div>
                                    <h2 class="heading">
                                        Notes
                                    </h2>
                                    <p class="text-sm-light">
                                    </p>
                                </div>

                                <div>
                                    <button type="button" (click)="onCloseModal()"
                                        class="rounded-lg p-1 text-left text-base/6 font-medium text-zinc-950 dark:text-white sm:text-sm/5 hover:bg-zinc-950/5 dark:hover:bg-white/5">
                                        <span class="sr-only">Close panel</span>
                                        <!-- Heroicon name: outline/x-mark -->
                                        <svg class="size-5" xmlns="http://www.w3.org/2000/svg" fill="none"
                                            viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
                                            aria-hidden="true">
                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                d="M6 18L18 6M6 6l12 12" />
                                        </svg>
                                    </button>
                                </div>

                            </div>

                            <hr class="my-4 mt-4 w-full border-t border-zinc-950/10 dark:border-white/10" />
                            <section class="flex-1 flex flex-col overflow-y-auto">
                                <ul role="list" class="">
                                    <form action="" class="space-y-6">
                                        <div>
                                            <label for="generalNotes"
                                                class="block text-sm font-medium text-main-secondary">General
                                                Notes</label>
                                            <div class="mt-1">
                                                <textarea [(ngModel)]="notes.generalNotes" rows="4" name="generalNotes" type="text" [readonly]="source === 'staging'"
                                                    class="resize-none form-control ng-pristine ng-untouched ng-valid ng-empty"
                                                    id="generalNotes"></textarea>
                                            </div>
                                        </div>
                                        <div *ngIf="source !== 'staging'">
                                            <label for="privateNotes" class="block text-sm font-medium text-main-secondary">
                                                Private Notes</label>
                                            <div class="mt-1">
                                                <textarea [(ngModel)]="notes.privateNotes" rows="4" name="privateNotes" type="text"
                                                    class="resize-none form-control ng-pristine ng-untouched ng-valid ng-empty"
                                                    id="privateNotes"></textarea>
                                            </div>
                                        </div>
                                        <div *ngIf="source !== 'staging'">
                                            <label for="billingNotes" class="block text-sm font-medium text-main-secondary">
                                                Billing Notes</label>
                                            <div class="mt-1">
                                                <textarea [(ngModel)]="notes.billingNotes" rows="4" name="billingNotes" type="text"
                                                    class="resize-none form-control ng-pristine ng-untouched ng-valid ng-empty"
                                                    id="billingNotes"></textarea>
                                            </div>
                                        </div>
                                    </form>
                                </ul>
                            </section>
                            <section  *ngIf="source !== 'staging'" class="mt-2 flex justify-end gap-4">
                                <button (click)="onUpdateNote()" type="button" class="btn btn-secondary"> Update </button>
                            </section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>